// angular
//   .module("HeroPRO")
//   .filter("makeRange", makeRange);

export default function makeRange() {
    return function makeRangeFilter(input) {
        let lowBound;
        let highBound;
        switch (input.length) {
        case 1:
            lowBound = 0;
            highBound = parseInt(input[0]) - 1;
            break;
        case 2:
            lowBound = parseInt(input[0]);
            highBound = parseInt(input[1]);
            break;
        default:
            return input;
        }
        const result = [];
        for (let i = lowBound; i <= highBound; i++) {
            result.push(i);
        }
        return result;
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/filters/range.filter.js